<template>
  <button
    @click="$emit('click')"
    class="floating-add-btn"
    :class="`floating-add-btn--${variant}`"
    :aria-label="ariaLabel"
  >
    <span class="floating-btn-icon">
      <IconSvg name="plus-solid-full" size="md" />
    </span>
  </button>
</template>

<script>
import IconSvg from "@/components/IconSvg.vue";

export default {
  name: "FloatingAddButton",
  components: { IconSvg },
  props: {
    variant: {
      type: String,
      default: "shiori",
      validator: (value) => ["shiori", "board"].includes(value),
    },
    ariaLabel: {
      type: String,
      default: "Create shiori",
    },
  },
  emits: ["click"],
};
</script>

<style scoped>
.floating-add-btn {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  width: 4rem;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    135deg,
    var(--primary-color) 0%,
    var(--primary-hover) 100%
  );
  color: white;
  border: none;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(180, 207, 158, 0.4),
    0 8px 24px rgba(180, 207, 158, 0.2);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  z-index: 1000;
}

.floating-add-btn:hover {
  box-shadow: 0 6px 16px rgba(180, 207, 158, 0.5),
    0 12px 32px rgba(180, 207, 158, 0.3);
  transform: scale(1.1);
}

.floating-add-btn:active {
  transform: scale(1.05);
}

.floating-add-btn:focus-visible {
  outline: 3px solid var(--primary-hover);
  outline-offset: 3px;
}

.floating-add-btn--board {
  background: linear-gradient(135deg, #8ca87a 0%, #b4cf9e 100%);
  box-shadow: 0 4px 12px rgba(140, 168, 122, 0.42),
    0 8px 24px rgba(180, 207, 158, 0.24);
}

.floating-add-btn--board:hover {
  background: #8ca87a;
  box-shadow: 0 6px 16px rgba(140, 168, 122, 0.5),
    0 12px 32px rgba(180, 207, 158, 0.3);
}

.floating-add-btn--board:active {
  background: #7f9968;
}

.floating-add-btn--board:focus-visible {
  outline-color: #8ca87a;
}

.floating-add-btn--board .floating-btn-icon img {
  filter: brightness(0) invert(1);
}

.floating-btn-icon img {
  filter: brightness(0);
}

.plus-icon {
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
}
</style>
